import { createRoot } from "react-dom/client";
import { App } from "./App";
import { RouteProvider } from "./router";
import { splashScreen, ThemeProvider } from "./theme";
import Intercom from "@intercom/messenger-js-sdk";
import { getEnv } from "./env";

Intercom({
    app_id: getEnv().INTERCOM_APP_ID,
});
createRoot(document.getElementById("root")!).render(
    <RouteProvider>
        <ThemeProvider splashScreen={splashScreen}>
            <App />
        </ThemeProvider>
    </RouteProvider>,
);
